var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","hide-on-single-page":_vm.count == 0,"page-sizes":[10, 20, 30, 50, 100],"page-size":_vm.size,"current-page":Number(_vm.page),"total":_vm.count,"layout":"prev, pager, next"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }